// extracted by mini-css-extract-plugin
export default {"label":"Label__label--3XE","readOnly":"Label__readOnly--1pt","hint":"Label__hint--2fX","fieldLabelAsterisk":"Label__fieldLabelAsterisk--1Nv","tooltipIcon":"Label__tooltipIcon--3vP"};